module.exports = __webpack_public_path__ + "img/discord.ed8a4b2d.svg";